import { lazy } from 'react';
import type { RouteObject } from 'react-router';

const DirectoryPage = lazy(() => import('./directory-page').then((m) => ({ default: m.DirectoryPage })));

export const catalogRoutes: RouteObject[] = [{ path: 'catalog', element: <DirectoryPage />, handle: { crumb: 'Service Catalog' } }];
